import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next"; // Ensure correct imports
import ListReport from "../../components/common/Tabs/ListReport";
import { Row, Tabs } from "antd";
import ListSpam from "../../components/common/Tabs/ListSpam";
import "./../../assets/style/pageStyle/spamManagement.scss";
import { useDispatch } from "react-redux";
import {
  getListFileSpam,
  getListTypeSpam,
} from "../../services/slice/SpamSlice";
const SpamManagement = () => {
  const { t } = useTranslation();
  const [tab, setTab] = React.useState(1);
  const [config, setConfig] = useState({});
  const dispatch = useDispatch();
  const handleChangeTabs = (key) => {
    setTab(key);
  };
  useEffect(() => {
    dispatch(getListTypeSpam());
  }, []);
  return (
    <div className="wrapperListSpam">
      <Row className="tableContent">
        <Tabs
          activeKey={tab}
          onChange={handleChangeTabs}
          items={[
            {
              label: t("Danh sách spam"),
              key: 1,
              children: <ListSpam />,
            },
            {
              label: t("Danh sách report"),
              key: 2,
              children: <ListReport />,
            },
          ]}
        />
      </Row>
    </div>
  );
};

export default SpamManagement;
